const VERSION = "7.1.1";
export {
  VERSION
};
